module.exports = __webpack_public_path__ + "static/media/yash_shah.13610ef6.png";